export interface IHideProps {
  isHidden: boolean
}
export const hide = ({ isHidden }: IHideProps) => (isHidden ? `display: none;` : '')
